// Shared across every TinyMCE `<editor>` instance in the app so the button group only has to change in one place.
export const ALIGN_TOOLBAR_GROUP = 'alignleft aligncenter alignright alignjustify';

// Needs TinyMCE >= 5.10. Pair with `line_height_formats: LINE_HEIGHT_FORMATS` in the editor init.
export const LINE_HEIGHT_TOOLBAR_BUTTON = 'lineheight';
export const LINE_HEIGHT_FORMATS = '1 1.15 1.5 2 2.5 3';
